// "Sentiment Analysis" section — per-question answer table with sentiment score columns.

import React from "react";
import {
    Typography,
    Select,
    Option,
} from "@material-tailwind/react";
import Trademark from "components/Trademark";
import {
    GobbyTable,
    GobbyTableHead,
    GobbyTableBody,
    GobbyTableRow,
    GobbyTableHeader,
    GobbyTableCell,
} from "components/ui/gobby-table";
import { percentFormat } from "../data-transforms";

export function SentimentAnalysisSection({
    questionResponsesSentiment,
    questionSentimentIndex,
    setQuestionSentimentIndex,
}) {
    return (
        <div>
            <Typography
                variant="h4"
                className="ml-2 text-black w-2/3"
            >
                Sentiment Analysis
            </Typography>
            <div>
                <div className="rounded-lg bg-white w-full">
                    {!!questionResponsesSentiment && (
                        <>
                            <Select
                                color="blue-gray"
                                label="Click here to select a question from the survey"
                                value={questionSentimentIndex?.toString()}
                                onChange={(e) => {
                                    const indexInt = parseInt(e);
                                    setQuestionSentimentIndex(
                                        indexInt,
                                    );
                                }}
                            >
                                {questionResponsesSentiment.map(
                                    (q, index) => (
                                        <Option
                                            key={q.id}
                                            value={`${index}`}
                                        >
                                            Question {q.position}:{" "}
                                            {q.text}
                                        </Option>
                                    ),
                                )}
                            </Select>
                            <GobbyTable className="mt-2">
                                <GobbyTableHead className="text-sm sm:text-lg">
                                    <GobbyTableRow>
                                        <GobbyTableHeader className="font-body w-5/12">
                                            Gobby
                                            <Trademark /> Response
                                        </GobbyTableHeader>
                                        <GobbyTableHeader className="font-body text-center w-2/12">
                                            Sentiment
                                        </GobbyTableHeader>
                                        <GobbyTableHeader className="font-body text-center w-1/12">
                                            Mixed
                                        </GobbyTableHeader>
                                        <GobbyTableHeader className="font-body text-center w-1/12">
                                            Positive
                                        </GobbyTableHeader>
                                        <GobbyTableHeader className="font-body text-center w-1/12">
                                            Negative
                                        </GobbyTableHeader>
                                        <GobbyTableHeader className="font-body text-center w-1/12">
                                            Neutral
                                        </GobbyTableHeader>
                                    </GobbyTableRow>
                                </GobbyTableHead>
                                <GobbyTableBody className="text-black text-right">
                                    {questionResponsesSentiment?.[
                                        questionSentimentIndex
                                    ]?.answers_with_sentiment.map(
                                        (answer) => (
                                            <GobbyTableRow
                                                key={answer.id}
                                            >
                                                <GobbyTableCell className="font-body text-left pl-2">
                                                    {answer.text}
                                                </GobbyTableCell>
                                                <GobbyTableCell className="text-center font-body">
                                                    {
                                                        answer
                                                            .sentiment
                                                            .sentiment
                                                    }
                                                </GobbyTableCell>
                                                <GobbyTableCell>
                                                    <span
                                                        className={`text-right font-body px-4 ${
                                                            answer
                                                                .sentiment
                                                                .score ===
                                                            answer
                                                                .sentiment
                                                                .mixed_score
                                                                ? "font-bold rounded-full text-center"
                                                                : ""
                                                        }`}
                                                    >
                                                        {percentFormat(
                                                            answer
                                                                .sentiment
                                                                .mixed_score,
                                                        )}
                                                    </span>
                                                </GobbyTableCell>
                                                <GobbyTableCell>
                                                    <span
                                                        className={`text-right font-body px-4 ${
                                                            answer
                                                                .sentiment
                                                                .score ===
                                                            answer
                                                                .sentiment
                                                                .positive_score
                                                                ? "font-bold rounded-full text-center"
                                                                : ""
                                                        }`}
                                                    >
                                                        {percentFormat(
                                                            answer
                                                                .sentiment
                                                                .positive_score,
                                                        )}
                                                    </span>
                                                </GobbyTableCell>
                                                <GobbyTableCell>
                                                    <span
                                                        className={`text-right font-body px-4 ${
                                                            answer
                                                                .sentiment
                                                                .score ===
                                                            answer
                                                                .sentiment
                                                                .negative_score
                                                                ? "font-bold rounded-full text-center"
                                                                : ""
                                                        }`}
                                                    >
                                                        {percentFormat(
                                                            answer
                                                                .sentiment
                                                                .negative_score,
                                                        )}
                                                    </span>
                                                </GobbyTableCell>
                                                <GobbyTableCell>
                                                    <span
                                                        className={`text-right font-body px-4 ${
                                                            answer
                                                                .sentiment
                                                                .score ===
                                                            answer
                                                                .sentiment
                                                                .neutral_score
                                                                ? "font-bold rounded-full text-center"
                                                                : ""
                                                        }`}
                                                    >
                                                        {percentFormat(
                                                            answer
                                                                .sentiment
                                                                .neutral_score,
                                                        )}
                                                    </span>
                                                </GobbyTableCell>
                                            </GobbyTableRow>
                                        ),
                                    )}
                                </GobbyTableBody>
                            </GobbyTable>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
